// Rondinella Market — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── SEARCH BAR ──────────────────────────────────────────
  const searchToggle = document.getElementById('rm-search-toggle');
  const searchBar = document.getElementById('rm-search-bar');
  const searchClose = document.getElementById('rm-search-close');
  const searchInput = searchBar ? searchBar.querySelector('.rm-search-bar__input') : null;

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      const isHidden = searchBar.hasAttribute('hidden');
      if (isHidden) {
        searchBar.removeAttribute('hidden');
        if (searchInput) searchInput.focus();
      } else {
        searchBar.setAttribute('hidden', '');
      }
    });
  }

  if (searchClose && searchBar) {
    searchClose.addEventListener('click', function () {
      searchBar.setAttribute('hidden', '');
    });
  }

  // Chiudi search con Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchBar && !searchBar.hasAttribute('hidden')) {
      searchBar.setAttribute('hidden', '');
    }
  });

  // ── MOBILE MENU ──────────────────────────────────────────
  const mobileToggle = document.getElementById('rm-mobile-menu-toggle');
  const mobileMenu = document.getElementById('rm-mobile-menu');
  const iconMenu = mobileToggle ? mobileToggle.querySelector('.rm-icon-menu') : null;
  const iconClose = mobileToggle ? mobileToggle.querySelector('.rm-icon-close') : null;

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = !mobileMenu.hasAttribute('hidden');
      if (isOpen) {
        mobileMenu.setAttribute('hidden', '');
        mobileToggle.setAttribute('aria-expanded', 'false');
        if (iconMenu) iconMenu.style.display = '';
        if (iconClose) iconClose.style.display = 'none';
        document.body.style.overflow = '';
      } else {
        mobileMenu.removeAttribute('hidden');
        mobileToggle.setAttribute('aria-expanded', 'true');
        if (iconMenu) iconMenu.style.display = 'none';
        if (iconClose) iconClose.style.display = '';
        document.body.style.overflow = 'hidden';
      }
    });
  }

  // Chiudi mobile menu su resize
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990 && mobileMenu && !mobileMenu.hasAttribute('hidden')) {
      mobileMenu.setAttribute('hidden', '');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      if (iconMenu) iconMenu.style.display = '';
      if (iconClose) iconClose.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  // ── STICKY HEADER ────────────────────────────────────────
  const headerWrapper = document.querySelector('.rm-header-wrapper--sticky');
  if (headerWrapper) {
    const headerHeight = headerWrapper.offsetHeight;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }

  // ── SMOOTH SCROLL ────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── CART AJAX (Add to cart senza reload) ─────────────────
  document.querySelectorAll('.rm-product-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.rm-btn');
      const originalText = btn.innerHTML;
      btn.innerHTML = '...';
      btn.disabled = true;

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.innerHTML = '✓ Aggiunto';
          btn.style.background = '#2D6A2D';
          btn.style.borderColor = '#2D6A2D';
          setTimeout(function () {
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 2000);
          // Aggiorna contatore carrello
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          const counter = document.querySelector('.rm-cart-count');
          if (cart.item_count > 0) {
            if (counter) {
              counter.textContent = cart.item_count;
            } else {
              const cartIcon = document.querySelector('.rm-header__icon--cart');
              if (cartIcon) {
                const span = document.createElement('span');
                span.className = 'rm-cart-count';
                span.textContent = cart.item_count;
                cartIcon.appendChild(span);
              }
            }
          }
        })
        .catch(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
        });
    });
  });

});
